import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class QuoteSubmissionService {
    constructor(private _http: HttpClient) {}

    quoteSubmissionUrl: string =
        environment.backend + environment.uri.cisaQuoteSubmission;

    cisaQuoteSubmission(quotePayload: any) {
        return this._http.post<any>(this.quoteSubmissionUrl, quotePayload).pipe(
            catchError((error: Response) => {
                return observableThrowError(error);
            })
        );
    }
}
